<template>
    <div class="apprentice-simple-card">
        <div
            class="not-found with-header empty-quest-assignment-list"
            v-if="levels.length === 0">
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                :title="$t('quest.add_level')"
                @click="newLevel"></div>
            <div class="alert-notice">{{ $t('quest.no_assignments_found') }}</div>
        </div>

        <div
            class="quest-assignments row"
            v-else>
            <div class="col-md-12 new-missions-group-buttons">
                <button
                    class="btn btn-sm btn-primary btn-newLevel"
                    @click="newLevel">
                    {{ $t('quest.add_level') }}
                </button>
                <button
                    class="btn btn-sm btn-primary btn-newCategory"
                    @click="newCategory">
                    {{ $t('quest.new_category') }}
                </button>
                <button
                    class="btn btn-sm btn-primary btn-newMission"
                    @click="newMission">
                    {{ $t('quest.new_assignment') }}
                </button>
            </div>
            <div class="col-md-12">
                <div role="tablist">
                    <draggable
                        group="level"
                        :list="levels"
                        handle=".level-drag-handle"
                        @change="levelOrderChanged()"
                        ghost-class="drag-ghost">
                        <b-card
                            class="level mission-level-card remove-box-shadow"
                            v-for="level in levels"
                            no-body
                            :key="level.id">
                            <b-card-header
                                class="missions-header"
                                v-b-toggle="'accordion-level' + level.id"
                                header-tag="header"
                                role="tab">
                                <span class="move">
                                    <i class="fas fa-fw fa-arrows-alt-v level-drag-handle"></i>
                                </span>
                                <div class="level-name">
                                    {{ level.name }}

                                    <div class="level-points">
                                        {{ level.score == null ? 0 : level.score }} {{ $t('quest.points') }}
                                    </div>
                                </div>

                                <div class="toggle-collapse">
                                    <i class="fas fa-fw fa-chevron-down"></i>
                                </div>

                                <div class="level-actions">
                                    <b-button
                                        class="btn-settings"
                                        v-b-tooltip="'Aanpassen'"
                                        variant="primary-icon-only"
                                        @click="editLevel(level)"
                                        :v-b-tooltip="$t('common.edit')"></b-button>

                                    <b-button
                                        class="btn-remove"
                                        variant="danger-icon-only"
                                        @click="deleteLevel(level.id)"
                                        :v-b-tooltip="$t('common.delete')"></b-button>
                                </div>
                            </b-card-header>
                            <b-collapse
                                class="category-container"
                                :id="'accordion-level' + level.id"
                                role="tabpanel">
                                <draggable
                                    v-if="level.categories.length >= 1"
                                    group="category"
                                    :list="level.categories"
                                    handle=".category-drag-handle"
                                    @change="categoryOrderChanged(level.id)"
                                    ghost-class="drag-ghost">
                                    <b-card
                                        class="missions-category-card remove-box-shadow"
                                        v-for="category in level.categories"
                                        no-body
                                        :key="category.id">
                                        <b-card-header
                                            class="category-header"
                                            v-b-toggle="'accordion-category' + category.id"
                                            header-tag="header"
                                            role="tab">
                                            <span class="move">
                                                <i class="fas fa-fw fa-arrows-alt-v category-drag-handle"></i>
                                            </span>
                                            <div class="category-name">
                                                {{ category.name }}
                                                <div class="category-points">
                                                    {{ category.score == null ? 0 : category.score }}
                                                    {{ $t('quest.points') }}
                                                </div>
                                            </div>
                                            <div class="toggle-collapse">
                                                <i class="fas fa-fw fa-chevron-down"></i>
                                            </div>
                                            <div class="category-actions">
                                                <b-button
                                                    class="btn-settings"
                                                    v-b-tooltip="'Aanpassen'"
                                                    variant="primary-icon-only"
                                                    @click="editCategory(category)"
                                                    :v-b-tooltip="$t('common.edit')"></b-button>

                                                <b-button
                                                    class="btn-remove"
                                                    v-b-tooltip="'Verwijderen'"
                                                    variant="danger-icon-only"
                                                    @click="deleteCategory(level.id, category.id)"
                                                    :v-b-tooltip="$t('common.delete')"></b-button>
                                            </div>
                                        </b-card-header>
                                        <b-collapse
                                            class="accordion-category"
                                            :id="'accordion-category' + category.id"
                                            role="tabpanel">
                                            <div
                                                class="missions"
                                                v-if="category.missions.length >= 1">
                                                <div
                                                    class="mission"
                                                    v-for="mission in category.missions"
                                                    :key="mission.id">
                                                    <div class="name">
                                                        {{ mission.name }}
                                                    </div>
                                                    <div class="mission-actions">
                                                        <b-button
                                                            class="btn-settings"
                                                            variant="primary-icon-only"
                                                            @click="editMission(mission.id)"
                                                            :v-b-tooltip="$t('common.edit')"></b-button>

                                                        <b-button
                                                            class="btn-remove"
                                                            variant="danger-icon-only"
                                                            @click="deleteMission(level.id, category.id, mission.id)"
                                                            :v-b-tooltip="$t('common.delete')"></b-button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="not-found with-header empty-category-list"
                                                v-else>
                                                <div class="icon">
                                                    <i class="fas fa-exclamation-circle"></i>
                                                </div>
                                                <div class="alert-notice">
                                                    {{ $t('quest.this_category_has_no_assignment') }}
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </b-card>
                                    <div class="missions category-less">
                                        <div
                                            class="mission"
                                            v-for="mission in level.missions"
                                            :key="mission.id">
                                            <div class="name">
                                                {{ mission.name }}
                                            </div>
                                            <div class="mission-actions">
                                                <b-button
                                                    class="btn-settings"
                                                    v-b-tooltip="'Aanpassen'"
                                                    variant="primary-icon-only"
                                                    @click="editMission(mission.id)"
                                                    :v-b-tooltip="$t('common.edit')"></b-button>

                                                <b-button
                                                    class="btn-remove"
                                                    variant="danger-icon-only"
                                                    @click="deleteMission(level.id, null, mission.id)"
                                                    :v-b-tooltip="$t('common.delete')"></b-button>
                                            </div>
                                        </div>
                                    </div>
                                </draggable>
                                <div
                                    class="not-found with-header empty-mission-list"
                                    v-else>
                                    <div class="icon">
                                        <i class="fas fa-exclamation-circle"></i>
                                    </div>
                                    <div class="alert-notice">
                                        {{ $t('quest.this_level_has_no_category_and_or_no_assignment') }}
                                    </div>
                                </div>
                            </b-collapse>
                        </b-card>
                    </draggable>
                </div>
            </div>
        </div>

        <b-modal
            id="quest-edit-level-modal"
            title="Level"
            :ok-title="$t('common.save')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal"
            @ok="saveLevel()">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('common.name') }}</label> <br />
                        <b-form-input
                            v-model="form_level_name"
                            :placeholder="$t('quest.level_name')"></b-form-input>
                    </div>
                    <div class="form-group">
                        <label>({{ $t('quest.minimum_score') }})</label> <br />
                        <b-form-input
                            v-model="form_level_score"
                            :placeholder="$t('quest.minimum_score')"></b-form-input>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="quest-edit-category-modal"
            :title="$t('quest.category')"
            :ok-title="$t('common.name')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal"
            @ok="saveCategory()">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('common.name') }}</label> <br />
                        <b-form-input
                            v-model="form_category_name"
                            :placeholder="$t('quest.category_name')"></b-form-input>
                    </div>
                    <div class="form-group">
                        <label>Level</label><br />
                        <b-form-select
                            class="apprentice-primary-select"
                            v-model="form_category_level"
                            :options="levels"
                            value-field="id"
                            text-field="name"></b-form-select>
                    </div>
                    <div class="form-group">
                        <label>{{ $t('quest.minimum_score_for_access') }}</label> <br />
                        <b-form-input
                            v-model="form_category_score"
                            :placeholder="$t('quest.minimum_score')"></b-form-input>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="quest-edit-mission-modal"
            :title="$t('quest.new_assignment')"
            :ok-title="$t('common.save')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal"
            @ok="saveMission()">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('common.title') }}</label> <br />
                        <b-form-input
                            v-model="form_mission_name"
                            :placeholder="$t('quest.title_assignment')"></b-form-input>
                    </div>
                    <div class="form-group">
                        <label>Level</label><br />
                        <b-form-select
                            class="apprentice-primary-select"
                            v-model="form_mission_level"
                            :options="levels"
                            value-field="id"
                            text-field="name"></b-form-select>
                    </div>
                    <div
                        class="form-group"
                        v-if="form_mission_level != null && categories.length > 0">
                        <label>{{ $t('quest.category') }}</label
                        ><br />
                        <b-form-select
                            class="apprentice-primary-select"
                            v-model="form_mission_category"
                            :options="categories"
                            value-field="id"
                            text-field="name"></b-form-select>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import ApprenticeEditor from '../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-quest-edit-missions-component',
    components: {
        draggable,
    },
    props: ['questId', 'levelsIn'],
    data() {
        return {
            quest: this.questIn,
            levels: this.levelsIn,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            form_level: null,
            form_level_name: null,
            form_level_score: null,
            form_category_id: null,
            form_category_name: null,
            form_category_level: this.levelsIn.length ? this.levelsIn[0].id : null,
            form_category_score: null,
            form_mission_name: null,
            form_mission_level: null,
            form_mission_category: null,
        };
    },
    computed: {
        categories() {
            if (this.form_mission_level !== null) {
                for (const level of this.levels) {
                    if (level.id === this.form_mission_level) {
                        return level.categories;
                    }
                }
            }
            return null;
        },
    },
    methods: {
        levelOrderChanged() {
            let blocks = [];

            this.levels.forEach((level, i) => {
                blocks.push({
                    id: level.id,
                    order: i + 1,
                });
            });

            const data = {
                blocks: blocks,
            };

            this.axios.post(this.routes.questEditLevelOrder(this.questId), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        categoryOrderChanged(level_id) {
            let blocks = [];

            for (const level of this.levels) {
                if (level.id == level_id) {
                    level.categories.forEach((category, i) => {
                        blocks.push({
                            id: category.id,
                            order: i + 1,
                        });
                    });
                }
            }

            const data = {
                blocks: blocks,
            };

            this.axios.post(this.routes.questEditCategoryOrder(this.questId, level_id), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        newMission() {
            this.form_mission_name = null;

            this.$bvModal.show('quest-edit-mission-modal');
        },
        saveMission() {
            this.alert.saving();

            var data = {
                name: this.form_mission_name,
                level: this.form_mission_level,
                category: this.form_mission_category,
            };

            this.axios.post(this.routes.questEditMissionAdd(this.questId), data).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.questEditMissionUrl(this.questId, response.data.mission.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        editMission(id) {
            window.location.href = this.routes.questEditMissionUrl(this.questId, id);
        },
        newLevel() {
            this.form_level = null;
            this.form_level_name = null;
            this.form_level_score = null;

            this.$bvModal.show('quest-edit-level-modal');
        },
        editLevel(level) {
            this.form_level = level.id;
            this.form_level_name = level.name;
            this.form_level_score = level.score;

            this.$bvModal.show('quest-edit-level-modal');
        },
        editCategory(category) {
            this.form_category = category.id;
            this.form_category_level = category.level_id;
            this.form_category_name = category.name;
            this.form_category_score = category.score;

            this.$bvModal.show('quest-edit-category-modal');
        },
        newCategory() {
            this.form_category = null;
            this.form_category_name = null;
            this.form_category_level = this.levelsIn.length ? this.levelsIn[0].id : null;
            this.form_category_score = null;

            this.$bvModal.show('quest-edit-category-modal');
        },
        saveCategory() {
            if (this.form_category == null) {
                this.alert.saving();

                var data = {
                    level: this.form_category_level,
                    name: this.form_category_name,
                    score: this.form_category_score,
                };

                this.axios.post(this.routes.questEditCategoryAdd(this.questId), data).then(
                    (response) => {
                        for (const level of this.levels) {
                            if (level.id == response.data.category.level_id) {
                                level.categories.push(response.data.category);
                            }
                        }
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.alert.saving();

                var data = {
                    id: this.form_category,
                    level: this.form_category_level,
                    name: this.form_category_name,
                    score: this.form_category_score,
                };

                this.axios.post(this.routes.questEditCategoryEdit(this.questId), data).then(
                    (response) => {
                        this.levels = response.data.levels;

                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
        saveLevel() {
            if (this.form_level == null) {
                this.alert.saving();

                var data = {
                    name: this.form_level_name,
                    score: this.form_level_score,
                };

                this.axios.post(this.routes.questEditLevelAdd(this.questId), data).then(
                    (response) => {
                        this.levels.push(response.data.level);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.alert.saving();

                var data = {
                    id: this.form_level,
                    name: this.form_level_name,
                    score: this.form_level_score,
                };

                this.axios.post(this.routes.questEditLevelEdit(this.questId), data).then(
                    (response) => {
                        this.levels = this.levels.map((level) => {
                            if (level.id == response.data.level.id) {
                                return response.data.level;
                            }
                            return level;
                        });

                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
        deleteLevel(id) {
            this.alert
                .confirm(this.$t('quest.delete_level'), this.$t('quest.are_you_sure_you_want_to_delete_this_level'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.questEditLevelDelete(this.questId, id)).then(
                            (response) => {
                                this.levels = this.levels.filter((level) => level.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        deleteCategory(level_id, id) {
            this.alert
                .confirm(
                    this.$t('quest.delete_category'),
                    this.$t('quest.are_you_sure_you_want_to_delete_this_category'),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.questEditCategoryDelete(this.questId, id)).then(
                            (response) => {
                                this.levels = this.levels.filter((level) => {
                                    if (level.id == level_id) {
                                        level.categories = level.categories.filter((category) => category.id != id);
                                    }

                                    return level;
                                });
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        deleteMission(level_id, category_id, id) {
            this.alert
                .confirm(
                    this.$t('quest.delete_assignment'),
                    this.$t('quest.are_you_sure_you_want_to_delete_this_assignment'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.questEditMissionDelete(this.questId, id)).then(
                            (response) => {
                                this.levels = this.levels.filter((level) => {
                                    if (level.id == level_id) {
                                        if (category_id == null) {
                                            level.missions = level.missions.filter((mission) => mission.id != id);
                                        } else {
                                            level.categories = level.categories.filter((category) => {
                                                if (category.id == category_id) {
                                                    category.missions = category.missions.filter(
                                                        (mission) => mission.id != id,
                                                    );
                                                }
                                                return category;
                                            });
                                        }
                                    }

                                    return level;
                                });

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.empty-quest-assignment-list {
    flex: 1;
    margin-top: 45px;
    margin-bottom: 45px;
}

.quest-assignments {
    width: 100%;
}

.new-missions-group-buttons {
    text-align: right;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
}

.new-missions-group-buttons .btn:not(:last-child) {
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
}

.mission-level-card {
    border: 0;
    border-radius: 0;
}

.missions-header,
.category-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: center;
    padding: 8px;
    background-color: $white;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    border-radius: $border-radius-content;
    border: 1px solid var(--primary);
    font-weight: $font-weight-normal;

    &:hover,
    &.not-collapsed {
        background-color: $info;
        border: 1px solid $info;

        .level-points,
        .level-name {
            color: $white;
            font-weight: $font-weight-bold;
        }
    }

    &:hover {
        cursor: pointer;
    }
}

.level-name,
.category-name {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: 1.125rem;
    line-height: 1.1;
    max-width: calc(100% - 96px);
}

.level-name,
.category-name,
.move {
    color: $text-color;
}

.level-name .level-points,
.category-name .category-points {
    font-size: 0.875rem;
    color: $text-muted-color;
}

.level-actions,
.category-actions {
    display: flex;
    justify-content: flex-end;
    align-self: baseline;
}

.level-actions .btn:last-child,
.category-actions .btn:last-child {
    margin-left: map-get($grid-gutter-spacing, 'eight');
}

.toggle-collapse {
    display: flex;
    align-items: center;
    cursor: pointer;
    align-self: baseline;
}

.toggle-collapse i:before {
    transition: all 1s ease-in-out;
}

.toggle-collapse:not(.collapsed) i:before {
    content: '\f077';
}

.category-container {
    padding-left: map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.missions-category-card {
    border: 0;

    .category-header {
        margin-bottom: 0;

        &:hover,
        &.not-collapsed {
            background-color: $info;
            border: 1px solid $info;

            .category-points,
            .category-name {
                color: $white;
                font-weight: $font-weight-bold;
            }
        }
    }

    &:not(:first-child) {
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.missions {
    padding-left: map-get($grid-gutter-spacing, 'fifteen');

    .mission {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: center;
        padding: map-get($grid-gutter-spacing, 'eight');
        align-items: center;
        border: 0;

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
        }
    }
}

.accordion-category {
    border: 0;

    .mission {
        border-top: 0;
    }
}

.mission .mission-actions {
    display: flex;
    flex: 1 0 100%;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'eight');
}

.mission .mission-actions .btn:last-child {
    margin-left: map-get($grid-gutter-spacing, 'eight');
}

.category-less .mission {
    padding-right: map-get($grid-gutter-spacing, 'eight');
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
}

.category-less .mission:last-child {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

@media (min-width: 768px) {
    .new-missions-group-buttons {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .new-missions-group-buttons .btn:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'ten');
        margin-bottom: 0;
    }
}

.empty-mission-list,
.empty-category-list {
    margin-top: $grid-gutter-width;
    margin-bottom: $grid-gutter-width;
}

@media (min-width: 992px) {
    .level-actions,
    .category-actions,
    .mission .mission-actions {
        flex: 0 1 auto;
        margin-left: map-get($grid-gutter-spacing, 'fifteen');
        align-items: center;
    }

    .mission .name {
        display: flex;
        flex: 1 0;
    }

    .mission .mission-actions {
        margin-top: 0;
    }
}
</style>
